import { TrendingUp, TrendingDown } from "lucide-react";

/**
 * StatCard — KPI tile with icon chip, value, label and optional trend pill.
 * Used in every module's stat row for a consistent dashboard feel.
 */
export default function StatCard({
  label,
  value,
  change,
  up = true,
  icon: Icon,
  iconBg = "var(--color-primary-tint)",
  iconColor = "var(--color-primary)",
  hint,
}) {
  return (
    <div
      className="bg-surface border border-border rounded-xl p-5 flex flex-col gap-3"
      style={{ boxShadow: "0 1px 8px rgba(0,0,0,0.05)" }}
    >
      <div className="flex items-start justify-between">
        {Icon && (
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: iconBg }}
          >
            <Icon className="w-4 h-4" style={{ color: iconColor }} />
          </div>
        )}
        {change != null && (
          <span
            className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full"
            style={{
              background: up ? "var(--color-success-bg)" : "var(--color-danger-bg)",
              color: up ? "var(--color-success)" : "var(--color-danger)",
            }}
          >
            {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
            {change}
          </span>
        )}
      </div>
      <div>
        <div className="text-2xl font-bold text-text_primary tracking-tight leading-none">{value}</div>
        <div className="text-xs text-text_muted mt-1">{label}</div>
        {hint && <div className="text-[11px] text-text_muted mt-1 opacity-80">{hint}</div>}
      </div>
    </div>
  );
}
